import React from 'react';
import { SubmittedSurvey } from '../types/admin';
import './ReportModal.css';

interface SurveyViewModalProps {
	isOpen: boolean;
	onClose: () => void;
	surveyData: SubmittedSurvey;
}

export const SurveyViewModal: React.FC<SurveyViewModalProps> = ({ isOpen, onClose, surveyData }) => {
	if (!isOpen) return null;

	const formatTimestamp = (timestampString?: string) => {
		if (!timestampString) return '';
		try {
			return new Date(timestampString).toLocaleString('sr-RS', {
				year: 'numeric',
				month: 'long',
				day: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});
		} catch (error) {
			return timestampString;
		}
	};

	const getRiskLevelText = (riskLevel: 'low' | 'medium' | 'high') => {
		switch (riskLevel) {
			case 'low':
				return 'Nizak';
			case 'medium':
				return 'Srednji';
			case 'high':
				return 'Visok';
			default:
				return riskLevel;
		}
	};

	const getTargetGroupText = (targetGroup: 'kids' | 'adults' | 'health-workers') => {
		switch (targetGroup) {
			case 'kids':
				return 'Deca';
			case 'adults':
				return 'Odrasli';
			case 'health-workers':
				return 'Zdravstveni radnici';
			default:
				return targetGroup;
		}
	};

	const formatAnswer = (answer: string | boolean | number) => {
		if (typeof answer === 'boolean') {
			return answer ? 'Da' : 'Ne';
		}
		if (answer === null || answer === undefined || answer === '') {
			return 'Nije odgovoreno';
		}
		return String(answer);
	};

	const groupAnswersBySection = () => {
		if (!surveyData?.answers) return {};

		const grouped: { [section: string]: typeof surveyData.answers } = {};

		surveyData.answers.forEach((answer) => {
			const section = answer?.question?.section?.title || 'Ostalo';
			if (!grouped[section]) {
				grouped[section] = [];
			}
			grouped[section].push(answer);
		});

		return grouped;
	};

	const groupedAnswers = groupAnswersBySection();

	return (
		<div className='report-modal-overlay'>
			<div className='report-modal'>
				<div className='report-modal-header'>
					<h2>Pregled ankete</h2>
					<p className='report-modal-subtitle'>Detalji popunjene ankete i procena rizika</p>

					{surveyData.submittedAt && (
						<p className='report-modal-subtitle'>
							Datum kreiranja: <strong>{formatTimestamp(surveyData.submittedAt)}</strong>
						</p>
					)}
					<button className='report-modal-close' onClick={onClose}>
						×
					</button>
				</div>

				<div className='report-modal-content'>
					<div className='report-form-view'>
						<div className='form-section'>
							<h3>Osnovni podaci</h3>

							<div className='report-form-row'>
								{/* <div className='form-group-view'>
									<label>ID ankete:</label>
									<span className='field-value'>{surveyData.id || 'Nije dostupno'}</span>
								</div> */}
								<div className='form-group-view'>
									<label>Ciljna grupa:</label>
									<span className='field-value'>{getTargetGroupText(surveyData.targetGroup)}</span>
								</div>
								<div className='form-group-view'>
									<label>Godine:</label>
									<span className='field-value'>{surveyData.age}</span>
								</div>
							</div>
						</div>

						{/* <div className='form-section mt-3'>
							<h3>Procena rizika</h3>

							<div className='report-form-row'>
								<div className='form-group-view'>
									<label>Nivo rizika:</label>
									<span className='field-value'>{getRiskLevelText(surveyData.riskLevel)}</span>
								</div>
								<div className='form-group-view'>
									<label>Skor rizika:</label>
									<span className='field-value'>{(surveyData.riskScore * 100).toFixed(1)}%</span>
								</div>
							</div>

							<div className='form-group-view full-width'>
								<label>Potencijalna trgovina ljudima:</label>
								<span className='field-value'>{surveyData.potentialTrafficking ? 'Da' : 'Ne'}</span>
							</div>
						</div> */}

						<div className='form-section mt-3'>
							<h3>Odgovori na pitanja</h3>

							{Object.keys(groupedAnswers).length === 0 ? (
								<div className='form-group-view full-width'>
									<p style={{ fontStyle: 'italic', color: '#666' }}>Nema zabeleženih pozitivnih odgovora</p>
								</div>
							) : (
								<div className='answers-sections'>
									{Object.entries(groupedAnswers).map(([section, answers]) => (
										<div key={section} className='answers-section'>
											<h3 className='section-title'>{section}</h3>
											<div className='answers-list'>
												{answers.map((answer, index) => (
													<div key={answer.question?.id || index} className='answer-item'>
														<div className='question-text'>{answer.question?.title || `${answer}`}</div>
														<div className='answer-value italic' style={{ color: '#666' }}>
															({answer.question?.score})
														</div>
														<div className='answer-value' style={{ fontWeight: answer.answer ? 'bold' : 500, color: answer.answer ? 'red' : '#666' }}>
															{formatAnswer(answer.answer)}
														</div>
													</div>
												))}
											</div>
										</div>
									))}
								</div>
							)}
						</div>
					</div>

					<div className='form-actions'>
						<button type='button' className='btn btn-primary' onClick={onClose}>
							Zatvori
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
